import React, {useState, useEffect, useCallback} from 'react';
import {View, ScrollView, Image, StyleSheet} from 'react-native';
import {connect} from 'react-redux';

import IntegrationsService from '../../services/IntegrationsService';
import {basicStyles} from '../../styles/basic';
import AppText from '../../components/AppText';
import {textStyles} from '../../styles/text';
import {IMAGE_PATH_INTEGRATION} from '../../config';
import FieldSet from '../../components/FieldSet';
import EStyleSheet from 'react-native-extended-stylesheet';
import PageContentContainer from "../../components/PageContentContainer";
import AppTextInput from "../../components/AppTextInput";
import AppButton from "../../components/AppButton";
import ToggleField from "../../components/ToggleField";

function ShippingIntegration(props) {
    const [integration, setIntegration] = useState({integrationImages: []});

    const [fedexApiKey, setFedexApiKey] = useState(props.auth.organization.organization_fedex_api_key || '');
    const [fedexSecretKey, setFedexSecretKey] = useState(props.auth.organization.organization_fedex_secret_key || '');
    const [fedexEnabled, setFedexEnabled] = useState(props.auth.organization.organization_fedex_enabled || '');

    const [upsClientId, setUpsClientId] = useState(props.auth.organization.organization_ups_client_id || '');
    const [upsClientSecret, setUpsClientSecret] = useState(props.auth.organization.organization_ups_client_secret || '');
    const [upsEnabled, setUpsEnabled] = useState(props.auth.organization.organization_ups_enabled || '');

    const [notifyShipped, setNotifyShipped] = useState(props.auth.organization.organization_tracking_notify_shipped || '')
    const [notifyShippedInternal, setNotifyShippedInternal] = useState(props.auth.organization.organization_tracking_notify_shipped_internal || 0)
    const [notifyDelivered, setNotifyDelivered] = useState(props.auth.organization.organization_tracking_notify_delivered || '')
    const [notifyDeliveredInternal, setNotifyDeliveredInternal] = useState(props.auth.organization.organization_tracking_notify_delivered_internal || 0)
    const [notifyException, setNotifyException] = useState(props.auth.organization.organization_tracking_notify_failed || '')
    const [notifyExceptionInternal, setNotifyExceptionInternal] = useState(props.auth.organization.organization_tracking_notify_failed_internal || 0)

    const [updatedMessage, setUpdatedMessage] = useState(null);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setUpdatedMessage(null);
        }, 3000);

        return () => clearTimeout(timeout);
    }, [updatedMessage]);

    const [buttonChunkSize, setButtonChunkSize] = useState(3);

    const handleLayout = ({nativeEvent}) => {
        const {width} = nativeEvent.layout;

        if (width > 840) {
            setButtonChunkSize(3);
        } else {
            setButtonChunkSize(1);
        }
    };

    useEffect(() => {
        const getIntegration = async () => {
            const integrationData = await IntegrationsService.getIntegration(props.route.params.id);

            setIntegration(integrationData);
        };

        const getConfig = async () => {
            const data = await IntegrationsService.getOrganizationShippingConfig(props.auth.organization.organization_id);
            if (data?.config) {
                setNotifyShipped(data.config.notifyShipped);
                setNotifyShippedInternal(data.config.notifyShippedInternal);
                setNotifyDelivered(data.config.notifyDelivered);
                setNotifyDeliveredInternal(data.config.notifyDeliveredInternal);
                setNotifyException(data.config.notifyFailed);
                setNotifyExceptionInternal(data.config.notifyFailedInternal);
            }
        }

        void getIntegration();
        void getConfig();
    }, [props.route.params.id, props.auth.organization.organization_id]);

    const handleSave = useCallback(async () => {
        void IntegrationsService.setOrganizationShippingConfig(props.auth.organization.organization_id, {
            fedexApiKey,
            fedexSecretKey,
            fedexEnabled,
            upsClientId,
            upsClientSecret,
            upsEnabled,
            notifyShipped,
            notifyShippedInternal,
            notifyDelivered,
            notifyDeliveredInternal,
            notifyException,
            notifyExceptionInternal,
        });

        setUpdatedMessage('Settings Saved!');
    }, [fedexApiKey, fedexSecretKey, fedexEnabled, upsClientId, upsClientSecret, upsEnabled, notifyShipped,
        notifyShippedInternal, notifyDelivered, notifyDeliveredInternal, notifyException, notifyExceptionInternal]);

    return (
        <ScrollView contentContainerStyle={basicStyles.flexScale} onLayout={handleLayout}>
            <View style={styles.contentWrapper}>
                <View style={[
                    basicStyles.alignContentCenter,
                    basicStyles.justifyContentSpaceBetween,
                    styles.contentContainer
                ]}>
                    <View style={[styles.contentLeft, basicStyles.alignContentCenter]}>
                        <View>
                            <AppText style={[
                                {fontSize: 28, marginBottom: 30},
                                textStyles.bold,
                            ]}>
                                {integration.integration_title}
                            </AppText>
                            <AppText style={{fontSize: 16, maxWidth: 465}}>
                                {integration.integration_description}
                            </AppText>
                        </View>
                    </View>
                    <View style={[styles.contentRight, basicStyles.alignContentCenter]}>
                        {
                            integration.integrationImages.length ?
                                <Image
                                    source={{uri: IMAGE_PATH_INTEGRATION + integration.integrationImages[0].integration_image_file}}
                                    style={styles.image} // todo: width or height HAS to be known in order for an image to scale...
                                    resizeMode="contain"
                                />
                                : null
                        }
                        <AppText style={{fontSize: '12', color: '#9BA8CA'}}>
                            {integration.integrationImages[0]?.integration_image_title}
                        </AppText>
                    </View>
                </View>

                <PageContentContainer>

                    {updatedMessage && (
                        <View>
                            <AppText style={[textStyles.pageSubTitle, textStyles.semiBold]}>
                                {updatedMessage}
                            </AppText>
                        </View>
                    )}

                    <View style={styles.fieldContainer}>
                        <AppText style={[textStyles.pageSubTitle, textStyles.semiBold]}>
                            UPS
                        </AppText>

                        <View style={styles.fieldSetRow}>
                            <AppTextInput
                                label={'Client ID'}
                                value={upsClientId}
                                onChangeText={setUpsClientId}
                                wrapperStyle={[styles.flex]}
                            />

                            <AppTextInput
                                label={'Client Secret'}
                                value={upsClientSecret}
                                onChangeText={setUpsClientSecret}
                                wrapperStyle={styles.flex}
                            />

                            <ToggleField
                                label={'Enabled?'}
                                value={upsEnabled}
                                onChange={setUpsEnabled}
                            />
                        </View>

                        <AppText style={[textStyles.pageSubTitle, textStyles.semiBold]}>
                            FedEx
                        </AppText>

                        <View style={styles.fieldSetRow}>
                            <AppTextInput
                                label={'API Key'}
                                value={fedexApiKey}
                                onChangeText={setFedexApiKey}
                                wrapperStyle={[styles.flex]}
                            />

                            <AppTextInput
                                label={'Secret Key'}
                                value={fedexSecretKey}
                                onChangeText={setFedexSecretKey}
                                wrapperStyle={styles.flex}
                            />

                            <ToggleField
                                label={'Enabled?'}
                                value={fedexEnabled}
                                onChange={setFedexEnabled}
                            />
                        </View>


                        <AppText style={[textStyles.pageSubTitle, textStyles.semiBold]}>
                            Notifications
                        </AppText>

                        <View style={styles.fieldSetRow}>
                            <View style={styles.toggleTextContainer}>
                                <ToggleField
                                    label={'Inbox?'}
                                    value={notifyShippedInternal}
                                    onChange={setNotifyShippedInternal}
                                    wrapperStyle={styles.toggleWrapper}
                                />

                                <AppTextInput
                                    label={'Shipped'}
                                    onChangeText={setNotifyShipped}
                                    value={notifyShipped}
                                    disabled={notifyShippedInternal}
                                    editable={!notifyShippedInternal}
                                    readonly={notifyShippedInternal}
                                    wrapperStyle={[
                                        styles.toggleTextWrapper,
                                        notifyShippedInternal ? styles.disabledTextField : null,
                                    ]}
                                />
                            </View>

                            <View style={styles.toggleTextContainer}>
                                <ToggleField
                                    label={'Inbox?'}
                                    value={notifyExceptionInternal}
                                    onChange={setNotifyExceptionInternal}
                                    wrapperStyle={styles.toggleWrapper}
                                />

                                <AppTextInput
                                    label={'Exception'}
                                    onChangeText={setNotifyException}
                                    value={notifyException}
                                    disabled={notifyExceptionInternal}
                                    editable={!notifyExceptionInternal}
                                    readonly={notifyExceptionInternal}
                                    wrapperStyle={[
                                        styles.toggleTextWrapper,
                                        notifyExceptionInternal ? styles.disabledTextField : null,
                                    ]}
                                />
                            </View>

                            <View style={styles.toggleTextContainer}>
                                <ToggleField
                                    label={'Inbox?'}
                                    value={notifyDeliveredInternal}
                                    onChange={setNotifyDeliveredInternal}
                                    wrapperStyle={styles.toggleWrapper}
                                />

                                <AppTextInput
                                    label={'Delivered'}
                                    onChangeText={setNotifyDelivered}
                                    value={notifyDelivered}
                                    disabled={notifyDeliveredInternal}
                                    editable={!notifyDeliveredInternal}
                                    readonly={notifyDeliveredInternal}
                                    wrapperStyle={[
                                        styles.toggleTextWrapper,
                                        notifyDeliveredInternal ? styles.disabledTextField : null,
                                    ]}
                                />
                            </View>
                        </View>
                    </View>

                    <AppButton
                        label="Save"
                        theme="green"
                        large={true}
                        action={handleSave}
                    />

                </PageContentContainer>

            </View>
        </ScrollView>
    );
}

const mapStateToProps = (state) => {
    const {auth} = state;
    return {auth};
};

export default connect(mapStateToProps)(ShippingIntegration);


const styles = EStyleSheet.create({
    contentWrapper: {
        paddingTop: 70,
        paddingBottom: 70,
        paddingLeft: 40,
        paddingRight: 40,
    },
    contentContainer: {
        flexDirection: 'row',
        paddingBottom: 60
    },
    contentLeft: {
        width: '50%',
        paddingRight: 40
    },
    contentRight: {
        width: '50%',
    },
    image: {
        width: 408,
        height: 315,
        marginBottom: 10,
    },
    fieldContainer: {
        backgroundColor: '#FFFFFF',
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 3,
        },
        shadowOpacity: 0.1,
        shadowRadius: 9.11,
        borderWidth: 1,
        borderColor: '#E2E9F4',
        borderRadius: 5,
        marginBottom: 50,
        paddingHorizontal: 15,
        paddingVertical: 15,
        // gap: 24,
    },
    flex: {
        flex: 1,
    },
    fieldSetRow: {
        flexDirection: 'row',
        gap: 24,
        marginBottom: 36,
    },
    toggleTextContainer: {
        flexDirection: 'row',
        flex: 1,
    },
    inputWrapper: {
        paddingLeft: 15,
        paddingRight: 15,
        marginBottom: 18,
    },
    toggleStyle: {
        borderRightWidth: 0,
    },
    toggleWrapper: {
        borderRightWidth: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    },
    toggleTextWrapper: {
        flex: 1,

        // borderLeftWidth: 0,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    disabledTextField: {
        backgroundColor: '#E5E5E5',
        opacity: 0.5,
    },
    '@media (max-width: 920)': {
        contentContainer: {
            flexDirection: 'column'
        },
        contentLeft: {
            width: '100%',
            paddingBottom: 50,
        },
        contentRight: {
            width: '100%'
        }
    },
    '@media (max-width: 408)': {
        contentWrapper: {
            paddingLeft: 0,
            paddingRight: 0,
        },
        contentLeft: {
            paddingLeft: 20,
            paddingRight: 20,
        },
        image: {
            width: 350
        },
        inputStyles: {
            paddingBottom: 20,
        },
        buttonStyles: {
            height: 'auto', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'inherit'
        },
    },
    '@media (max-width: 350)': {
        contentLeft: {
            paddingBottom: 10,
        },
        image: {
            width: 280
        },
    }
});
